// extracted by mini-css-extract-plugin
export default {"starsContent":"style-module--starsContent--MPEj1","countReviewers":"style-module--countReviewers--O0Vxp"};